import {
  ArchiveCodeBookMutation,
  ArchiveCodeBookMutationVariables,
  CancelCodeBookImportMutation,
  CancelCodeBookImportMutationVariables,
  CreateCodeBookMutation,
  CreateCodeBookMutationVariables,
  CreateCodeBookWithCsvImportMutation,
  CreateCodeBookWithCsvImportMutationVariables,
  GetCodeBooksForCardsQuery,
  GetCodeBooksForCardsQueryVariables,
  GetCodeBooksQuery,
  GetCodeBooksQueryVariables,
  UpdateCodeBookMutation,
  UpdateCodeBookMutationVariables,
} from '../../types/graphql'
import { useMyOrgId } from '../layouts/AppStateContextLayout/utils'
import { QueryKey, useMutation, useQuery } from '../utils/queryClient'

const CreateMutation = gql`
  mutation CreateCodeBookMutation($input: CreateCodeBookInput!) {
    createCodeBook(input: $input) {
      id
    }
  }
`

export const useCreateCodeBookMutation = () => {
  return useMutation<CreateCodeBookMutation, CreateCodeBookMutationVariables>({
    mutationDocument: CreateMutation,
  })
}

const CreateWithCsvImportMutation = gql`
  mutation CreateCodeBookWithCsvImportMutation($input: CreateCodeBookWithCsvImportInput!) {
    createCodeBookWithCsvImport(input: $input) {
      id
    }
  }
`

export const useCreateCodeBookWithCsvImportMutation = () => {
  return useMutation<
    CreateCodeBookWithCsvImportMutation,
    CreateCodeBookWithCsvImportMutationVariables
  >({
    mutationDocument: CreateWithCsvImportMutation,
  })
}

const Get = gql`
  query GetCodeBooksQuery($input: GetCodeBooksInput) {
    codeBooks(input: $input) {
      ...CodeBookFragment
    }
  }
`

const GetForCards = gql`
  query GetCodeBooksForCardsQuery($input: GetCodeBooksInput) {
    codeBooks(input: $input) {
      ...CodeBookListCardFragment
    }
  }
`

export const useCodeBooksQuery = (options?: { enabled?: boolean }) => {
  const organizationId = useMyOrgId()
  return useQuery<GetCodeBooksQuery, GetCodeBooksQueryVariables>({
    queryKey: [QueryKey.CodeBooks, organizationId],
    queryDocument: Get,
    variables: { input: { organizationId } },
    enabled: options?.enabled ?? true,
  })
}

export const useCodeBooksForCardsQuery = (options?: { enabled?: boolean }) => {
  const organizationId = useMyOrgId()
  return useQuery<GetCodeBooksForCardsQuery, GetCodeBooksForCardsQueryVariables>({
    queryKey: [QueryKey.CodeBooksForCards, organizationId],
    queryDocument: GetForCards,
    variables: { input: { organizationId } },
    enabled: options?.enabled ?? true,
  })
}

const UpdateMutation = gql`
  mutation UpdateCodeBookMutation($id: Int!, $input: CreateCodeBookInput!) {
    updateCodeBook(id: $id, input: $input) {
      id
    }
  }
`

export const useUpdateCodeBookMutation = () => {
  return useMutation<UpdateCodeBookMutation, UpdateCodeBookMutationVariables>({
    mutationDocument: UpdateMutation,
  })
}

const ArchiveMutation = gql`
  mutation ArchiveCodeBookMutation($id: Int!) {
    archiveCodeBook(id: $id) {
      id
    }
  }
`

export const useArchiveCodeBookMutation = () => {
  return useMutation<ArchiveCodeBookMutation, ArchiveCodeBookMutationVariables>({
    mutationDocument: ArchiveMutation,
  })
}

const CancelImportMutation = gql`
  mutation CancelCodeBookImportMutation($id: Int!) {
    cancelCodeBookImport(id: $id) {
      id
    }
  }
`

export const useCancelCodeBookImportMutation = () => {
  return useMutation<CancelCodeBookImportMutation, CancelCodeBookImportMutationVariables>({
    mutationDocument: CancelImportMutation,
  })
}
